const settings = {
  prependPath: '',
  title: 'La Cañada Flintridge',
  additionalLocations: [
    {
      title: 'Santa Clarita',
      url: 'https://santaclarita.wealthwisdomwellness.us',
    },
  ],
  yelpSearchUrl: 'https://api.yelp.com/v3/businesses/search',
  proxy: 'https://cors-anywhere.herokuapp.com/',
  resultsPerPage: 12,
  latitude: 34.207721,
  longitude: -118.206979,
  radius: 20000,
};

export default settings;
